import { Title, PARAGRAPH, SUBTITLE, TITLE } from '../components';
import { BudgetSplitSection } from '../components/BudgetSplitSection';

const ThirdPage = () => {
  return (
    <div>
      <Title
        Title={TITLE.WEEKLY_BUDGET_SPLIT}
        Subtitle={SUBTITLE.STEP_THREE}
        Paragraph={PARAGRAPH.PARAGRAPH_THREE}
      />
      <BudgetSplitSection />
    </div>
  );
};

export default ThirdPage;
